import React from 'react';
import * as S from './estilos';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import ImgBanner from '../../Images/Banner.jpg';
import ImgBannerResp from '../../Images/BannerResp.jpg';

interface User {
  typeWeb?: boolean;
  link?: string;
  data: any;
}

const Banner = ({ data, link, typeWeb = false }: User) => {
  console.log(data.normal);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <>
      <div id="Home"></div>
      <Slider className='SliderBanner1' {...settings}>
        {data.map((data: any) =>
          typeWeb ? (
            <>
              <S.ImgBanner
                key={data.normal}
                src={data.normal}
                // onClick={() => (data.link ? window.open(data.link) : null)}
              />
            </>
          ) : (
            <>
              <S.ImgBanner
                key={data.normal}
                src={data.normal}
                // onClick={() => (data.link ? window.open(data.link) : null)}
              />
            </>
          ),
        )}
      </Slider>

      <Slider className='SliderBanner2' {...settings}>
        {data.map((data: any) =>
          typeWeb ? (
            link && (
              <div key={data.responsive} onClick={() => (data.link ? window.open(data.link) : null)}>
                <S.ImgBannerResp key={data.responsive} src={data.responsive} />
              </div>
            )
          ) : (
            <>
              <S.ImgBannerResp
                key={data.responsive}
                src={data.responsive}
                // onClick={() => (data.link ? window.open(data.link) : null)}
              />
            </>
          ),
        )}
      </Slider>
    </>
  );
};

export default Banner;
